import { IConditionContext } from "./Interfaces/IConditionContext";
import { FieldModel, FieldDropdownComponent, FieldDropdownComponentProps } from "../../Dropdowns/FieldDropdownComponent";
import { IDropdown } from "../../Interfaces/IDropdown";
import { Condition } from "../../../Pages/Measure/VisibilityDependency/Condition";
import { TemplateCategoryField } from "../../../Areas/Admin/Measures/TemplateEdit/Models/TemplateCategoryField";
import { Template } from "../../../Areas/Admin/Measures/TemplateEdit/Models/Template";
import { TemplateFieldBase } from "../../../Areas/Admin/Measures/TemplateEdit/Models/TemplateFieldBase";
import { TemplateFieldTypes } from "../../../Areas/Admin/Shared/Models/TemplateFieldTypes";
import { DropDownComponent, DropDownComponentProps } from "../../DropDownComponent";
import { FieldHelper } from "../../../Common/FieldHelper";
import { ITreeField } from "../../../Frame/GridViewSelect/ITreeField";
import { DynamicFieldControlType } from "../../../Controls/Dynamic/DynamicFieldControlType";
import { IFieldAndValueModel } from "../../../Pages/Measure/VisibilityDependency/IFieldAndValueModel";


export class TemplateConditionContext implements IConditionContext {
    constructor(private model: Condition, private template: Template, private fields: TemplateFieldBase[], private isSubCategoryIncluded: boolean = false, private includeTmassnahmeFields: boolean = false) { }

    public dropdown: IDropdown;
    private identifier: string;

    getFieldControl(): IDropdown {
        //let identifier: string;
        if (this.isSubCategoryIncluded && this.model.isSubCategory) {
            this.identifier = "combinedIdentifier";

            // Create new identifier property on condition. We need this to be able to set a value in the dropdown, when the condition already exists.
            this.model[this.identifier] = this.model.fieldGuid;
            if (this.model.categoryId && this.model.categoryId != 0) {
                this.model[this.identifier] = this.model[this.identifier] + "_" + this.model.categoryId;
            }
        } else {
            this.identifier = "fieldGuid"
        }

        let fieldDropdownProps: FieldDropdownComponentProps = {
            model: this.model,
            template: this.template,
            fields: this.fields,
            field: this.identifier,
            name: Resources.Common.labelField,
            onChange: this.onChange,
            includeSubCategories: this.isSubCategoryIncluded,
            includeTMassnahmeFields: this.includeTmassnahmeFields
        }
        this.dropdown = new FieldDropdownComponent(fieldDropdownProps);
        return this.dropdown;
    }

    onChange = (control: DropDownComponent) => {
        let field = control.getSelectedItem().field;
        if (field) {
            let selectedItem = control.getSelectedItem();

            
            this.model.fieldId = field["id"];
            this.model.fieldGuid = field.guid ?? field.fieldName;
            this.model.fieldType = field.type?.toString() ?? field.valueType;
            this.model[this.identifier] = selectedItem.value;
            if (field.type == TemplateFieldTypes.Category) {
                // Split identifier
                if (selectedItem.value && selectedItem.value.indexOf("_") > -1) {
                    var categoryIdString = selectedItem.value.split("_")[1];
                    let categoryId = Number(categoryIdString);

                    if (!isNaN(categoryId)) {
                        this.model.categoryId = categoryId;
                    }
                }
            }
            this.model.fieldName = selectedItem.name;
        }

    }

    selectedFieldExists = (): boolean => {
        let fieldsToSearch: TemplateFieldBase[];
        if (this.template) {
            fieldsToSearch = this.template.fields.items;
        } else if (this.fields) {
            fieldsToSearch = this.fields;
        } else {
            throw new Error("Either template or fields properties have to have a value.");
        }

        if (fieldsToSearch) {
            let fields = fieldsToSearch.filter(f => f.guid == this.model.fieldGuid)
            if (fields.some) {
                return true
            }
        }
        return false;
    }

    setField = (triggerOnChange: boolean = true): void => {
        this.dropdown.setValue(this.model[this.identifier], triggerOnChange);
    }

    getSelectedCategoryID = (field: any): number => {
        let typedField = field as FieldModel;
        if (typedField) {
            return (typedField.field as TemplateCategoryField).categoryId;
        }
        throw new Error("Field is an invalid data type.");
    }

    getSelectedLocalFieldID(field: any): number {
        let typedField = field as FieldModel;
        if (typedField) {
            //TODO
            return 0;
        }
        throw new Error("Field is an invalid data type.");
    }

    getStatusFromParentSourceUrl(field: any): string {
        let typedField = field as FieldModel;
        if (typedField) {
            let field = typedField.field as TemplateFieldBase;
            if (field) {
                return `~/api/dynamic/getParentStatusByTemplate/${field.templateId}`;
            }
            return null;
        }
        throw new Error("Field is an invalid data type."); 
    }

    getOperators(fieldControl: IDropdown): { name: string; value: string; }[] {
        let field = (fieldControl.getSelectedItem() as FieldModel).field;

        let operators: { name: string, value: string }[];

        if (field instanceof TemplateFieldBase) {
            operators = this.getOperatorsForFieldType((field as TemplateFieldBase).type);
        } else {
            operators = this.getOperatorsForTreeField((field as ITreeField));
        }

        return operators;
    }

    getOperatorsForTreeField(field: ITreeField): { name: string; value: string; }[] {
        let operators: { name: string, value: string }[] = [];

        // TableField TMassnahme
        switch (DynamicFieldControlType[field.valueType]) {
            case DynamicFieldControlType.TextBox:
            case DynamicFieldControlType.RichText:
            case DynamicFieldControlType.MultiLine:
                operators = [
                    { name: Resources.Common.suchenIstGleich, value: "like" },
                    { name: Resources.Common.suchenIstUngleich, value: "not like" },
                    { name: Resources.Common.suchenBeginntMit, value: "left" },
                    { name: Resources.Common.suchenEnthaelt, value: "contains" },
                    { name: Resources.Common.suchenEnthaeltNicht, value: "not contains" },
                    { name: Resources.Common.suchenIstNull, value: "null" }
                ];
                break;
            case DynamicFieldControlType.Category:
                operators = [
                    { name: Resources.Common.suchenIstGleich, value: "=" },
                    { name: Resources.Common.suchenIstUngleich, value: "<>" },
                    { name: Resources.Common.suchenIstNotNull, value: "not null" },
                    { name: Resources.Common.suchenIstNull, value: "null" }
                ];
            case DynamicFieldControlType.YesNo:
                operators = [
                    { name: Resources.Common.suchenIstGleich, value: "=" },
                    { name: Resources.Common.suchenIstUngleich, value: "<>" }
                ];
                break;
            case DynamicFieldControlType.Double:
            case DynamicFieldControlType.Int:
                if (DynamicFieldControlType[field.valueType] == DynamicFieldControlType.Int &&
                    (field.fieldName == "EreignisId" || field.fieldName == "Ampel" || field.fieldName == "StatusEBlockId")) {
                    operators = [
                        { name: Resources.Common.suchenIstGleich, value: "=" },
                        { name: Resources.Common.suchenIstUngleich, value: "<>" }
                    ];
                } else {
                    operators = [
                        { name: Resources.Common.suchenIstGleich, value: "=" },
                        { name: Resources.Common.suchenIstUngleich, value: "<>" },
                        { name: Resources.Common.suchenIstGroesser, value: ">" },
                        { name: Resources.Common.suchenIstKleiner, value: "<" },
                        { name: Resources.Common.suchenIstGroesserGleich, value: ">=" },
                        { name: Resources.Common.suchenIstKleinerGleich, value: "<=" },
                        { name: Resources.Common.suchenIstNull, value: "null" },
                    ];
                }
                break;
            case DynamicFieldControlType.DatePicker:
                operators = [
                    { name: Resources.Common.suchenIstGleich, value: "=" },
                    { name: Resources.Common.suchenIstUngleich, value: "<>" },
                    { name: Resources.Common.suchenIstGroesser, value: ">" },
                    { name: Resources.Common.suchenIstKleiner, value: "<" },
                    { name: Resources.Common.suchenIstGroesserGleich, value: ">=" },
                    { name: Resources.Common.suchenIstKleinerGleich, value: "<=" },
                    { name: Resources.Common.suchenIstNull, value: "null" },
                    { name: Resources.Common.dateFilterToday, value: "today" },
                    { name: Resources.Common.dateFilterTomorrow, value: "tomorrow" },
                ];
                break;
            case DynamicFieldControlType.MultiUser:
                operators = [
                    { name: Resources.Common.suchenIstGleich, value: "=" },
                    { name: Resources.Common.suchenIstUngleich, value: "<>" },
                    { name: Resources.Common.suchenIch, value: "me" }
                ];
            case DynamicFieldControlType.UserList:
                operators = [
                    { name: Resources.Common.suchenEnthaelt, value: "=" },
                    { name: Resources.Common.suchenEnthaeltNicht, value: "<>" },
                    { name: Resources.Common.suchenIstNull, value: "null" },
                    { name: Resources.Common.suchenIstNichtNull, value: "not null" },
                    { name: Resources.Common.suchenIch, value: "me" }
                ];
                break;
            default:
                break;
        }

        return operators;
    }

    getOperatorsForFieldType = (type: TemplateFieldTypes, showCurrentDateOptions?: boolean): { name: string, value: string }[] => {
        let operators: { name: string, value: string }[];

        switch (type) {
            case TemplateFieldTypes.Mehrzeilig:
            case TemplateFieldTypes.Textzeile:
            case TemplateFieldTypes.RichText:
            case TemplateFieldTypes.Title:
            case TemplateFieldTypes.ParentContentText:
            case TemplateFieldTypes.NotesList:
                operators = [
                    { name: Resources.Common.suchenIstGleich, value: "like" },
                    { name: Resources.Common.suchenIstUngleich, value: "not like" },
                    { name: Resources.Common.suchenBeginntMit, value: "left" },
                    { name: Resources.Common.suchenEnthaelt, value: "contains" },
                    { name: Resources.Common.suchenEnthaeltNicht, value: "not contains" },
                    { name: Resources.Common.suchenIstNull, value: "null" }
                ];
                break;
            case TemplateFieldTypes.Category:
                operators = [
                    { name: Resources.Common.suchenIstGleich, value: "=" },
                    { name: Resources.Common.suchenIstUngleich, value: "<>" }
                ];
                break;
            case TemplateFieldTypes.JaNein:
            case TemplateFieldTypes.BlockFinished:
            case TemplateFieldTypes.ParentStatus:
                operators = [
                    { name: Resources.Common.suchenIstGleich, value: "=" },
                    { name: Resources.Common.suchenIstUngleich, value: "<>" }
                ];
                break;
            case TemplateFieldTypes.Zahl:
            case TemplateFieldTypes.ParentContentNumber:
            case TemplateFieldTypes.DateDiff:
                operators = [
                    { name: Resources.Common.suchenIstGleich, value: "=" },
                    { name: Resources.Common.suchenIstUngleich, value: "<>" },
                    { name: Resources.Common.suchenIstGroesser, value: ">" },
                    { name: Resources.Common.suchenIstKleiner, value: "<" },
                    { name: Resources.Common.suchenIstGroesserGleich, value: ">=" },
                    { name: Resources.Common.suchenIstKleinerGleich, value: "<=" },
                    { name: Resources.Common.suchenIstNull, value: "null" }
                ];
                break;
            case TemplateFieldTypes.Datum:
            case TemplateFieldTypes.BlockDate:
            case TemplateFieldTypes.ParentContentDate:
                if (showCurrentDateOptions) {
                    operators = [
                        { name: Resources.Common.suchenIstGleich, value: "=" },
                        { name: Resources.Common.suchenIstUngleich, value: "<>" },
                        { name: Resources.Common.suchenIstGroesser, value: ">" },
                        { name: Resources.Common.suchenIstKleiner, value: "<" },
                        { name: Resources.Common.suchenIstGroesserGleich, value: ">=" },
                        { name: Resources.Common.suchenIstKleinerGleich, value: "<=" },
                        { name: Resources.Common.suchenIstNull, value: "null" },
                        { name: Resources.Common.dateFilterToday, value: "today" },
                        { name: Resources.Common.dateFilterTomorrow, value: "tomorrow" },
                    ];
                }
                else {
                    operators = [
                        { name: Resources.Common.suchenIstGleich, value: "=" },
                        { name: Resources.Common.suchenIstUngleich, value: "<>" },
                        { name: Resources.Common.suchenIstGroesser, value: ">" },
                        { name: Resources.Common.suchenIstKleiner, value: "<" },
                        { name: Resources.Common.suchenIstGroesserGleich, value: ">=" },
                        { name: Resources.Common.suchenIstKleinerGleich, value: "<=" },
                        { name: Resources.Common.suchenIstNull, value: "null" }
                    ];
                }
                break;
            case TemplateFieldTypes.Benutzer:
            case TemplateFieldTypes.BlockResponsible:
            case TemplateFieldTypes.Responsible:
            case TemplateFieldTypes.ParentContentUser:
                operators = [
                    { name: Resources.Common.suchenIstGleich, value: "=" },
                    { name: Resources.Common.suchenIstUngleich, value: "<>" },
                    { name: Resources.Common.suchenIch, value: "me" }
                ];
                break;
            case TemplateFieldTypes.UserList:
            case TemplateFieldTypes.ParentContentUserList:
                operators = [
                    { name: Resources.Common.suchenEnthaelt, value: "contains" },
                    { name: Resources.Common.suchenEnthaeltNicht, value: "<>" },
                    { name: Resources.Common.suchenIstNull, value: "null" },
                    { name: Resources.Common.suchenIstNotNull, value: "not null" },
                    { name: Resources.Common.suchenIch, value: "me" }
                ];
                break;
            default:
                operators = [];
                break;

        }
        return operators;
    }

    getValueType(fieldControl: IDropdown): string {
        return FieldHelper.getValueType(fieldControl);
    }

    getValueTypeForFieldType = (type: TemplateFieldTypes) => {
        return FieldHelper.getValueTypeForFieldType(type);
    }

    private checkIfStringIsGuid(value: string): boolean {
        const regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
        if (regexExp.test(value)) {
            return true;
        }
        else {
            return false;
        }
    }

    public getTemplate = () => {
        return this.template;
    }

    getCompareFieldControl(model: IFieldAndValueModel): IDropdown {
        return null;
    }
}